import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22.0375 7.57319L16.4272 1.96289L12.2309 6.15922L17.8412 11.7695L22.0375 7.57319Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M16.427 13.1837L10.817 7.57373L1.99976 16.3904V22.0007L7.61005 22.0007L16.427 13.1837Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M12.6815 22.0007H22.2245V20.0007L12.6815 20.0007V22.0007Z"}}]};

const Edit2Filled = Vue.extend<IconProps>({
  name: 'Edit2FilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'edit-2-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default Edit2Filled;
